module.exports = __webpack_public_path__ + "static/media/1950.d67ff662.jpeg";